import { useCallback, useEffect, useState } from 'react';

import type { PaymentMethodType } from 'api/payments';
import { useNotifications } from 'store';
import { useTranslation } from 'utils/translations';

export type PaymentError = {
  status: number;
  code: string;
  message: string;
  traceId: string;
  violationInfo: {
    clientId: number;
    limit: number;
    currentValue: number;
    limitType: string;
  };
  timestamp: number;
};

export type UsePaymentNotificationProps = {
  imageSources?: Record<PropertyKey, string | undefined>;
  paymentError?: PaymentError;
  paymentMethod?: PaymentMethodType;
  errorNotify?: (error: PaymentError) => void;
};

export const useErrorNotification = () => {
  const [{ add }] = useNotifications();
  const [error, setError] = useState<PaymentError | null>(null);
  const translatedErrorCode = useTranslation(error?.code?.toLowerCase() || '');
  const errorMessage =
    translatedErrorCode !== '#' ? translatedErrorCode : error?.message;

  useEffect(() => {
    if (!error) return;

    if (errorMessage) {
      add({
        type: 'error',
        text: errorMessage,
      });
    }
  }, [add, errorMessage, error]);

  const errorNotify = useCallback((paymentError: PaymentError) => {
    if (paymentError) {
      setError(paymentError);
    }
  }, []);

  return errorNotify;
};
